import React, { Component } from "react";
import PropTypes from "prop-types";
import CareerForm from "./career_form";
import CareerEdit from "./career_edit";

class MyCareerPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isEditMode: false
    };
  }

  handleEditModeLinkClick = () => {
    this.setState(prevState => (
      { isEditMode: !prevState.isEditMode }
    ));
  };

  render() {
    const { isEditMode } = this.state;
    const { careers } = this.props;

    return (
      <section className='row d-flex justify-content-center' id='experience' name='experience'>
        <div id='object_unit' className='col-12 col-sm-10'>
          <h2>
            EXPERIENCE
            <button type='button' className='btn-profile-edit' onClick={this.handleEditModeLinkClick}>
              <span className='d-none d-md-inline'>経歴の</span>
              { isEditMode === true ? "編集完了" : "編集" }
            </button>
          </h2>

          { isEditMode === true && (
            <CareerForm
              {...this.props}
              handleEditModeLinkClick={this.handleEditModeLinkClick}
            />
          )}

          { careers.length > 0 && (
            <table className='table'>
              <tbody>
                {careers.map(career => {
                  return (
                    <tr key={career.id}>
                      <CareerEdit
                        career={career}
                        isEditMode={isEditMode}
                        {...this.props}
                      />
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}

          { careers.length == 0 && isEditMode === false && (
            <button type='button' className='container content-null' onClick={this.handleEditModeLinkClick}>
              <p>
                <i className="fas fa-edit mr-1" />
                  経歴の情報を追加しましょう
              </p>
            </button>
          )}
        </div>
      </section>
    );
  }
}

MyCareerPage.propTypes = {
  careers: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default MyCareerPage;
